var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "delivery-create" },
    [
      _c(
        "el-card",
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(
                  _vm._s(
                    _vm.isEdit
                      ? "编辑发货单"
                      : _vm.isInstruction
                      ? "发货单详情"
                      : "创建发货单"
                  )
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: {
                    float: "right",
                    padding: "3px 0",
                    "margin-left": "10px",
                  },
                  attrs: {
                    type: "text",
                    icon: "el-icon-refresh",
                    loading: _vm.refreshing,
                  },
                  on: { click: _vm.handleRefresh },
                },
                [_vm._v("刷新")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { float: "right", padding: "3px 0" },
                  attrs: { type: "text" },
                  on: { click: _vm.goBack },
                },
                [_vm._v("返回")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "validate-on-rule-change": false,
                "label-width": "120px",
              },
            },
            [
              _c("OrderInfo", {
                attrs: {
                  "contract-list": _vm.contractList,
                  loading: _vm.tableLoading,
                  "table-height": _vm.tableHeight,
                  "current-page": _vm.currentPage,
                  "page-size": _vm.pageSize,
                  total: _vm.total,
                  "delivery-type": _vm.form.deliveryType,
                  editable: !_vm.isEdit && !_vm.isInstruction,
                  "commission-errors": _vm.commissionErrors,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                  "commission-change": _vm.handleCommissionChange,
                },
              }),
              _vm._v(" "),
              _vm.form.deliveryType === "配送(到家)"
                ? _c("DeliveryPeisong", {
                    ref: "deliveryPeisong",
                    attrs: {
                      form: _vm.form,
                      "send-status": _vm.sendStatus,
                      "customer-info": _vm.customerInfo,
                      "amap-api": _vm.amapApi,
                      "amap-security-js-code": _vm.amapSecurityJsCode,
                      "is-edit": _vm.isEdit,
                      initiator: _vm.initiator,
                      "initiate-time": _vm.initiateTime,
                      submitting: _vm.isSubmitting,
                      "all-driver-list": _vm.allDriverList,
                      "contract-list": _vm.contractList,
                      "detail-id": _vm.detailId,
                      "accounting-total-packages": _vm.accountingTotalPackages,
                      "accounting-total-in-packages":
                        _vm.accountingTotalInPackages,
                      "accounting-total-area": _vm.accountingTotalArea,
                      "accounting-total-vol": _vm.accountingTotalVol,
                    },
                    on: {
                      "attachment-change": _vm.onPeisongAttachmentChange,
                      save: _vm.handleSave,
                      cancel: _vm.goBack,
                      "reload-contract": _vm.handleRefresh,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.form.deliveryType === "快递"
                ? _c("DeliveryKuaidi", {
                    ref: "deliveryKuaidi",
                    attrs: {
                      form: _vm.form,
                      "is-edit": _vm.isEdit,
                      initiator: _vm.initiator,
                      "initiate-time": _vm.initiateTime,
                      "send-status": _vm.sendStatus,
                      "delivery-log": _vm.deliveryLog,
                      submitting: _vm.isSubmitting,
                      "send-task-id": _vm.sendTaskId,
                      "contract-list": _vm.contractList,
                    },
                    on: {
                      "open-address": _vm.openAddressSelector,
                      "delivery-submit": _vm.handleDeliverySubmit,
                      save: _vm.handleSave,
                      cancel: _vm.goBack,
                      "audit-done": _vm.handleAuditDone,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.form.deliveryType === "自提"
                ? _c("DeliveryZiti", {
                    ref: "deliveryZiti",
                    attrs: {
                      form: _vm.form,
                      "is-edit": _vm.isEdit,
                      initiator: _vm.initiator,
                      "initiate-time": _vm.initiateTime,
                      "send-status": _vm.sendStatus,
                      "delivery-log": _vm.deliveryLog,
                      submitting: _vm.isSubmitting,
                      "send-task-id": _vm.sendTaskId,
                      "contract-list": _vm.contractList,
                    },
                    on: {
                      "open-address": _vm.openAddressSelector,
                      "delivery-submit": _vm.handleDeliverySubmit,
                      save: _vm.handleSave,
                      cancel: _vm.goBack,
                      "audit-done": _vm.handleAuditDone,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.form.deliveryType === "物流"
                ? _c("DeliveryWuliu", {
                    ref: "deliveryWuliu",
                    attrs: {
                      form: _vm.form,
                      "is-edit": _vm.isEdit,
                      initiator: _vm.initiator,
                      "initiate-time": _vm.initiateTime,
                      "send-status": _vm.sendStatus,
                      "delivery-log": _vm.deliveryLog,
                      submitting: _vm.isSubmitting,
                      "send-task-id": _vm.sendTaskId,
                      "contract-list": _vm.contractList,
                    },
                    on: {
                      "open-address": _vm.openAddressSelector,
                      "delivery-submit": _vm.handleDeliverySubmit,
                      save: _vm.handleSave,
                      cancel: _vm.goBack,
                      "audit-done": _vm.handleAuditDone,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.form.deliveryType === "配送(到物流点)"
                ? _c("DeliveryWuliuDian", {
                    ref: "deliveryWuliuDian",
                    attrs: {
                      form: _vm.form,
                      "send-status": _vm.sendStatus,
                      "customer-info": _vm.customerInfo,
                      "amap-api": _vm.amapApi,
                      "amap-security-js-code": _vm.amapSecurityJsCode,
                      "is-edit": _vm.isEdit,
                      initiator: _vm.initiator,
                      "initiate-time": _vm.initiateTime,
                      submitting: _vm.isSubmitting,
                      "all-driver-list": _vm.allDriverList,
                      "contract-list": _vm.contractList,
                      "detail-id": _vm.detailId,
                      "accounting-total-packages": _vm.accountingTotalPackages,
                      "accounting-total-in-packages":
                        _vm.accountingTotalInPackages,
                      "accounting-total-area": _vm.accountingTotalArea,
                      "accounting-total-vol": _vm.accountingTotalVol,
                    },
                    on: {
                      "attachment-change": _vm.onPeisongAttachmentChange,
                      save: _vm.handleSave,
                      cancel: _vm.goBack,
                      "reload-contract": _vm.handleRefresh,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.form.deliveryType === "闪送"
                ? _c("DeliveryShansong", {
                    ref: "deliveryShansong",
                    attrs: {
                      form: _vm.form,
                      "is-edit": _vm.isEdit,
                      initiator: _vm.initiator,
                      "initiate-time": _vm.initiateTime,
                      "send-status": _vm.sendStatus,
                      submitting: _vm.isSubmitting,
                      "send-task-id": _vm.sendTaskId,
                      "contract-list": _vm.contractList,
                      "delivery-log": _vm.deliveryLog,
                    },
                    on: {
                      "open-address": _vm.openAddressSelector,
                      "delivery-submit": _vm.handleDeliverySubmit,
                      save: _vm.handleSave,
                      cancel: _vm.goBack,
                      "audit-done": _vm.handleAuditDone,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isEdit
            ? _c("DeliveryActions", {
                attrs: {
                  "edit-id": _vm.editId,
                  "detail-id": _vm.detailId,
                  "delivery-no": _vm.form.deliveryNo,
                  "send-task-id": _vm.sendTaskId,
                  "send-status": _vm.sendStatus,
                  "prev-status": _vm.prevStatus,
                  "can-operate": _vm.canOperate,
                  "show-step-back":
                    _vm.sendStatus != 10 &&
                    _vm.sendStatus !== 1010 &&
                    _vm.sendStatus !== 1011,
                  "show-remind":
                    _vm.sendStatus === 10 ||
                    _vm.sendStatus === 20 ||
                    _vm.sendStatus === 30 ||
                    _vm.sendStatus === 40,
                  "contract-list": _vm.contractList,
                  "delivery-type": _vm.form.deliveryType,
                },
                on: {
                  revoked: _vm.handleRevoked,
                  "step-back": _vm.handleStepBack,
                  save: _vm.handleSave,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("AddressSelector", {
            attrs: {
              "current-receive-person": _vm.form.receivePerson,
              "current-receive-phone": _vm.form.receivePhone,
              "current-receive-address": _vm.form.receiveAddress,
            },
            on: { select: _vm.onAddressSelect },
            model: {
              value: _vm.addressSelectVisible,
              callback: function ($$v) {
                _vm.addressSelectVisible = $$v
              },
              expression: "addressSelectVisible",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }